import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { hasTokenManager } from './TokenManager';
import { hasUserDetailManager } from './UserDetailManager';
import config from '../../config';
import { withTranslationProvider, HTMLTrans } from '../Common/Translations';
import { compose } from 'recompose';
import { ContinueWithFacebook, ContinueWithGoogle } from '../Account/SocialLoginButtons';
import { connectBackendConfig } from '../Common/connectBackendConfig'

class Login extends Component {
  constructor(props) {
    super(props);

    this._login = this._login.bind(this);
    this._toRegister = this._toRegister.bind(this);
    this._toForgotPassword = this._toForgotPassword.bind(this);

    if (this.props.location && this.props.location.query
      && this.props.location.query.redirect_uri) {
      this.redirectUri = this.props.location.query.redirect_uri.split('?')[0];
    }
  }

  _login(event){
    const self = this;
    const redirectUri = this.redirectUri;
    event.preventDefault();
    var o = {email:this.email.value, password:this.password.value};
    $.post(config.localeApi+'/login', o,
      (response) => {
        toastr.success(
            `${this.props.t("navbar.auth_login_welcome", "Welcome")} ${response.data.user.first_name} !!`, '',
            {"positionClass": "toast-bottom-full-width"}
        );
        self.props.setToken(response.data.token);
        self.props.setDetail(response.data.user);

        if (self.props.updateToken) {
            self.props.updateToken(response.data.token);
        }
        if (redirectUri) {
            window.location = `${redirectUri}?token=${response.data.token}`;
        }

        if (!this.props.closeModal) {
            window.location = this.props.tRoute('/account/dashboard/order');
        }

      }, 'json'
    ).fail((response) => {
        if ('string' === typeof response.responseJSON.errors) {
          toastr.error(
            response.responseJSON.errors, '',
            {"positionClass": "toast-bottom-full-width"}
          );
        } else {
          Object.keys(response.responseJSON.errors).map(x => {
            toastr.error(
              response.responseJSON.errors[x], '',
              {"positionClass": "toast-bottom-full-width"}
            );
          });
        }
    });
  }

  _toRegister(event) {
    event.preventDefault();
    if (this.props.updateFormState) {
      this.props.updateFormState('register');
    } else {
      this.props.router.push(this.props.tRoute('/account/register'));
    }
  }

  _toForgotPassword(event) {
    event.preventDefault();
    if (this.props.updateFormState) {
      this.props.updateFormState('forgotpassword');
    } else {
      this.props.router.push(this.props.tRoute('/account/forgotpassword'));
    }
  }

  render() {
    const {
      t,
      backendConfig: {
        facebookIntegrationEnabled = false
      } = {},
      updateToken,
      setToken,
    } = this.props;
    return (
            <form className="card border-0" method="post">
                <div className="modal-header">
                  <p className="text-primary font-weight-bold h3"><HTMLTrans id='navbar.auth_login_title'>Login</HTMLTrans></p>
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="modal-body pt-0">
                  {this.props.isFromEditor &&
                    <div className='login-save text-center'>
                      <HTMLTrans id='navbar.login_save'>
                        Secure Your Creation! <br/>Log in or Create an Account now to save your progress and ensure uninterrupted access and editing!
                      </HTMLTrans>
                    </div>
                  }
                  {facebookIntegrationEnabled && 
                    <ContinueWithFacbook text={t('navbar.auth_facebook', 'Continue with Facebook')} closeModal={updateToken} setToken={setToken} />
                  }
                  <ContinueWithGoogle text={t('navbar.auth_google', 'Continue with Google')} closeModal={updateToken} setToken={setToken} />
                  <div className="form-group">
                    <div className="row pt-4">
                      <div className="col"><hr/></div>
                      <div className="col-auto"><p className="ProximaNova-Bold text-gray-lighten-2 text-center m-1">OR</p></div>
                      <div className="col"><hr/></div>
                    </div>
                  </div>
                    <div className="form-group">
                      <label htmlFor="email" className="ProximaNova-Bold"><HTMLTrans id='navbar.auth_login_email_label'>Email</HTMLTrans></label>
                        <input type="text" id="loginEmailTextbox" className="form-control" ref={input => this.email = input} placeholder={t('navbar.auth_login_email_placeholder', 'Email')}></input>
                    </div>
                    <div className="form-group">
                      <label htmlFor="password" className="ProximaNova-Bold"><HTMLTrans id='navbar.auth_login_password_label'>Password</HTMLTrans></label>
                        <input type="password" id="loginPasswordTextbox" className="form-control" ref={input => this.password = input} placeholder={t('navbar.auth_login_password_placeholder', 'Password')}></input>
                    </div>
                    <div className="row justify-content-between">
                        <div className="col form-check">
                            <label className="custom-control custom-checkbox">
                                <input type="checkbox" className="custom-control-input"/>
                                <span className="custom-control-indicator"/>
                                <span className="custom-control-description">
                                  <small><HTMLTrans id='navbar.auth_login_remember_me'>Remember me</HTMLTrans></small>
                                </span>
                            </label>
                        </div>
                        <div className="col text-right">
                          <a href="#" onClick={this._toForgotPassword}><u><small id="forgotPasswordLink"><HTMLTrans id='navbar.auth_login_forgot_password'>Forgot password?</HTMLTrans></small></u></a>
                        </div>
                    </div>
                    <div className="text-center">
                      <button className="btn btn-lg btn-block btn-primary" onClick={this._login} id="loginButton"><HTMLTrans id='navbar.auth_login_login_url'>Login</HTMLTrans></button>
                    </div>
                </div>
                <div className="modal-footer justify-content-center pt-0">
                  <p className="text-gray m-1"><HTMLTrans id='navbar.auth_login_new_here'>New here?</HTMLTrans>  </p>
                  <a href="#" className="ml-2 text-primary" onClick={this._toRegister}><u><HTMLTrans id='navbar.auth_login_create_account_link'>Create an account</HTMLTrans></u></a>
                </div>
            </form>
    );
  }
}

const enhance = compose(
  hasUserDetailManager,
  hasTokenManager,
  withRouter,
  withTranslationProvider,
  connectBackendConfig,
);

export default enhance(Login);



// WEBPACK FOOTER //
// ./src/Auth/Login.js